// NOTE: We have this here since we can't set window at the top level
import $ from 'jquery';

window.jQuery = $;
window.$ = $;
